"use client";
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import NextLink from "next/link";
import { useTranslation } from "react-i18next";

const BG_IMAGE =
  "https://getgeek-website-assets.b-cdn.net/SageFinalCtaSectionBg.webp";

const SageFinalCtaSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 2, sm: 2, md: 2 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            backgroundColor: "#14122B", // image load hone tak fallback
            backgroundImage: `url(${BG_IMAGE})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: { xs: "16px", md: "22px" },
            px: { xs: 3, sm: 5, md: 8 },
            py: { xs: 5, md: 7 },
            textAlign: "center",
          }}
        >
          {/* Content */}
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "22px", sm: "28px", md: "34px", lg: "36px" },
                fontWeight: 700,
                lineHeight: 1.25,
                color: "#FFFFFF",
                fontFamily: "var(--font-plusjakarta)",
                mb: { xs: 1.5, md: 2 },
              }}
            >
              {t("sageFinalCta.heading")}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                color: "rgba(255,255,255,0.85)",
                lineHeight: 1.7,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
                maxWidth: 420,
                mx: "auto",
                mb: { xs: 3, md: 3.5 },
              }}
            >
              {t("sageFinalCta.description")}
            </Typography>

            <NextLink
              href="/free-trial-of-ai-recruiting-tool"
              passHref
              legacyBehavior
            >
              <Button
                component="a"
                sx={{
                  bgcolor: "#7A2BF5",
                  color: "white",
                  px: { xs: 3, sm: 3.5 },
                  py: { xs: 1.2, sm: 1.4 },
                  borderRadius: "50px",
                  textTransform: "none",
                  fontSize: { xs: "14px", sm: "15px" },
                  fontWeight: 500,
                  fontFamily: "var(--font-outfit)",
                  whiteSpace: "nowrap",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    bgcolor: "#7A2BF5",
                    transform: "scale(1.03)",
                  },
                }}
              >
                {t("sageFinalCta.cta")}
              </Button>
            </NextLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SageFinalCtaSection;